import { faX } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useState, useEffect } from "react"
import CustomerDetails from "./CustomerDetails"
import LoadingAnimation from "../LoadingAnimation"

interface Props {
    displayForm: (value:boolean) => void
}

interface CartItem {
    id: string;
    title: string;
    size: string;
    colour: string;
    quantity: number;
    image: string;
    price: number;
}

export default function CheckoutForm({displayForm}: Props) {
    const [insideForm, setInsideForm] = useState<boolean>(false)
    const [cartItems, setCartItems] = useState<CartItem[]>([])
    const [displaySecondaryForm, setDisplaySecondaryForm] = useState<boolean>(false)
    const [loadingForm, setLoadingForm] = useState<boolean>(false)

    // Close the form if user clicks outside of it
    function handleExit(value:boolean){
        if(!insideForm){
            displayForm(value)
        }
    }
    // Retrieve current items in cart
    function getCart() {
        const cookies = document.cookie.split("; ")
        const cartCookie = cookies.find(row => row.startsWith("cart="))
        return cartCookie ? JSON.parse(decodeURIComponent(cartCookie.split("=")[1])) : []
    }
    // Uupdate cart with item changes
    function updateCart(item: CartItem, operation: "+" | "-") {
        let cart = getCart()
        let existingItem = cart.find((cartItem: CartItem) => cartItem.id === item.id)
    
        if (existingItem) {
            existingItem.quantity = operation === "+" ? existingItem.quantity + 1 : Math.max(existingItem.quantity - 1, 1)
        } else if (operation === "+") {
            cart.push({ ...item, quantity: 1 })
        }
    
        document.cookie = `cart=${encodeURIComponent(JSON.stringify(cart))}; path=/; max-age=86400`
        setCartItems(cart)
    }
    // Remove an item from the cart
    function removeFromCart(id: string) {
        const updatedCart = getCart().filter((item: any) => item.id !== id)
        document.cookie = `cart=${encodeURIComponent(JSON.stringify(updatedCart))}; path=/; max-age=86400`
        setCartItems(updatedCart)
    }
    
    useEffect(() => {
        setCartItems(getCart())
    }, [])

    return (
        <div className="pop-up-background">
            <div 
                className="pop-up-container h-4/5" 
                onMouseEnter={() => setInsideForm(true)} 
                onMouseLeave={() => setInsideForm(false)}
            >
                <div className="flex justify-center items-center p-3 lg:px-5 bg-main-white rounded-t-xl">
                    <FontAwesomeIcon 
                        icon={faX}
                        className="text-main-green-900 text-lg hover:text-main-green-500 mr-auto cursor-pointer"
                        onClick={() => handleExit(!true)}
                        onMouseEnter={() => setInsideForm(false)}
                    />
                    <h3 className="text-2xl font-semibold font-kulim underline mx-auto text-center pl-6">
                        Cart
                    </h3>
                    <p className="w-10 ml-auto mr-0"></p>
                </div>
                <div className="flex flex-col bg-main-white p-3 lg:px-5 rounded-b-xl">
                    {!displaySecondaryForm ?
                        <>
                            <div className="flex flex-col justify-start overflow-scroll h-96">
                                {cartItems.length > 0 ? (
                                    cartItems.map((item: any, index: number) => (
                                        <div key={index} className="flex flex-col justify-between w-full p-3 my-3 border-t border-b">
                                            <div className="flex w-full">
                                                <img 
                                                    src={item.image}
                                                    className="h-8 w-8 lg:w-16 lg:h-16 rounded-xl my-auto"
                                                />
                                                <p className="text-sm w-20 md:w-36 lg:w-52 xl:w-64 overflow-hidden text-ellipsis whitespace-nowrap lg:text-lg my-auto ml-4 mr-0">
                                                    {item.id}
                                                </p>
                                                <button 
                                                    className="text-xs text-main-grey-200 hover:text-main-grey-400 ml-2 lg:ml-4 mr-auto hover:cursor-pointer" 
                                                    onClick={() => removeFromCart(item.id)}
                                                >   
                                                    Remove
                                                </button>
                                                <div className="flex items-center justify-center">
                                                    <button 
                                                        onClick={() => updateCart(item, "-")}
                                                        className="px-3 pb-1.5 pt-1 rounded-full bg-main-grey-100 cursor-pointer my-auto"
                                                    >
                                                        -
                                                    </button>
                                                    <p className="mx-4">{item.quantity}</p>
                                                    <button 
                                                        onClick={() => updateCart(item, "+")}
                                                        className="px-3 pb-1.5 pt-1 rounded-full bg-main-grey-100 cursor-pointer my-auto"
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                            <p className="my-1 ml-24 mr-0 text-sm">{item.colour} / {item.size} </p>
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-center m-auto py-12">Your cart is empty.</p>
                                )}
                            </div>
                            <button 
                                className="form-btn px-5 mx-auto mt-10"
                                aria-label="submit merchandise order"
                                tabIndex={0}
                                disabled={cartItems.length === 0 || loadingForm}
                                onClick={()=>{
                                    // Trigger upon initial click
                                    setDisplaySecondaryForm(true);
                                    // Trigger loading animation
                                    setLoadingForm(true);
                                    setTimeout(() => {
                                        setLoadingForm(false)
                                    }, 1000);
                                }}
                            >
                                Next
                            </button>
                        </>
                    :
                        (loadingForm ?
                            <div className="mt-44 mb-48">
                                <LoadingAnimation />
                            </div>
                        :
                            <CustomerDetails />
                        )
                    }
                    
                </div>
            </div>
        </div>
    )
}
